import React from 'react';
import i18next from 'i18next';
import { string } from 'prop-types';

function ClientRow({ text, value, style }) {
  return (
    <div className="row middle">
      <div className={style}>
        <span className="bold font-size-14">{i18next.t(`OrdersDetails:${text}`)}</span>
      </div>
      <div>
        <span className="font-size-14">{value}</span>
      </div>
    </div>
  );
}

ClientRow.propTypes = {
  style: string.isRequired,
  text: string.isRequired,
  value: string.isRequired
};

export default ClientRow;
